/* ============
 * Customer KPI Store
 * ============
 */

import { defineStore } from 'pinia';
import './pinia';
import { useAccountStore } from './account';
import customerStats from '../services/data/customerStats';

let lastAccountsKpiRequest = 0;

export const useCustomerKpiStore = defineStore('customerKpi', {
  state: () => ({
    nbStudentsToRate: 0,
    nbStudentsToValidate: 0,
    nbQuoteToValidate: 0,
    nbContractsToSign: 0,
    accountsKpi: {},
  }),

  getters: {
    accountCount: (state) => (companyId, counter) => {
      const kpi = counter && state.accountsKpi[companyId];
      return kpi ? kpi[counter] || 0 : 0;
    },
  },

  actions: {
    countStudentsToRate(data) {
      this.nbStudentsToRate = data;
    },

    countStudentsToValidate(data) {
      this.nbStudentsToValidate = data;
    },

    countQuoteToValidate(data) {
      this.nbQuoteToValidate = data;
    },

    countContractsToSign(data) {
      this.nbContractsToSign = data;
    },

    async refreshAccountsKpi() {
      const { company } = useAccountStore();
      lastAccountsKpiRequest += 1;
      const request = lastAccountsKpiRequest;

      if (!company || !company.children || !company.children.length) {
        this.accountsKpi = {};
        return;
      }

      try {
        const data = await customerStats(company.id, { statistics: ['countStudentsToGiveFeedback', 'children'] });
        if (request !== lastAccountsKpiRequest) return;

        this.accountsKpi = Object.fromEntries([
          [company.id, { nbStudentsToRate: data.studentsKpi.nbStudentsToRate }],
          ...data.subAccountsKpi.map((kpi) => [kpi.customerId, kpi]),
        ]);
      } catch (error) {
        window.console.warn('customerKpi: accounts counters request failed', error && error.message);
      }
    },
  },
});

export default useCustomerKpiStore;
